const _ = "menu_BYiRK", n = "menu__header_Uj6nB", e = "menu__user_PncmU", t = "menu__user__name_ZpAST", u = "menu__user__login_qyW3q", o = "menu__user__account_7aGvf", m = "menu__content_GlXTL", c = "menu__content__action_XpbV8", s = "menu__content__linkButton_AQ-lH", r = "menu__content__linkList_d6Ard", i = {
  menu: _,
  menu__header: n,
  menu__user: e,
  menu__user__name: t,
  menu__user__login: u,
  menu__user__account: o,
  menu__content: m,
  menu__content__action: c,
  menu__content__linkButton: s,
  menu__content__linkList: r
};
export {
  i as default,
  _ as menu,
  m as menu__content,
  c as menu__content__action,
  s as menu__content__linkButton,
  r as menu__content__linkList,
  n as menu__header,
  e as menu__user,
  o as menu__user__account,
  u as menu__user__login,
  t as menu__user__name
};
//# sourceMappingURL=userMenu.module.scss.js.map
